import { render } from "./ReviewPep.vue?vue&type=template&id=64ff0833"
import script from "./ReviewPep.vue?vue&type=script&lang=js"
export * from "./ReviewPep.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__